export default {
  init() {
   let miVideo = document.getElementById('myVideo');
    $('#quitar-muteInterior').on( 'click' , function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-muteInterior').css('display','none');
        $('#mute-videoInterior').css('display','inline-block');
      }
    });

    $('#mute-videoInterior').on( 'click' , function (){
      if( $('video').prop('muted', false) ) {
        $('video').prop('muted', true);
        $('#quitar-muteInterior').css('display', 'inline-block');
        $('#mute-videoInterior').css('display', 'none');
      }
    });
    $('#playInterior').click( function (){
        miVideo.play();
        if( $('video').prop('muted', true) )
        {
          $('video').prop('muted', false);
        }
        $('#quitar-muteInterior').css('display','none');
        $('#mute-videoInterior').css('display','inline-block');
        $('#pauseInterior').css('display','inline-block');
        $('#playInterior').css('display','none');
    });

    $('#pauseInterior').click( function (){
      miVideo.pause();
      $('#playInterior').css('display','inline-block');
      $('#pauseInterior').css('display','none');
      $('#mute-videoInterior').css('display','none');
      $('#quitar-muteInterior').css('display','none');
    });
    // JavaScript to be fired on all pages
    $('.fichaCasting').on('mouseover', function(e){
      e.stopPropagation();
      $(this).find('.capaTextoDestacadoSubir').addClass( 'agrandar');
      $(this).find('.capaBotones').addClass( 'mostrar');
      $(this).find('.descGridDestacado').addClass( 'mostrar' );

    });

    $('.fichaCasting').on('mouseleave', function(e){
      e.stopPropagation();
      $(this).find('.capaBotones').removeClass( 'mostrar');
      $(this).find('.capaTextoDestacadoSubir').removeClass( 'agrandar');
      $(this).find('.descGridDestacado').removeClass( 'mostrar' );
    });

    let contador = 0;
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
       if(contador == 0 ) {
        $('.menuMovil').animate({
          'display': 'block',
          'left': '0',
        }, 500);
        contador = 1;
      } else {
        $('.menuMovil').animate({
          'display': 'block',
          'left': '-100vw',
        }, 500);
        contador = 0;
      }
    });


    var altura = $('.banner').offset().top;

    $(window).on('scroll', function(){
      if ( $(window).scrollTop() > altura ){
        $('.banner').addClass('menu-fixed');
      } else {
        $('.banner').removeClass('menu-fixed');
      }
    });
/*
    let miVar = $('.ImagenEntradas').data('imagen');
    let otraVAr = $('.ImagenEntradas').attr('src');

    $('.ImagenEntradas').on('mouseover',function() {

      $(this).fadeTo(100,0.30, function() {
        $(this).attr('src',miVar);
        $(this).on('load', function(){
          $(this).fadeTo(100,1);
        });
      });
      return false;

    });

    $('.ImagenEntradas').on('mouseout',function() {
      $(this).fadeTo(100,0.30, function() {
        $(this).attr('src',otraVAr);
        $(this).on('load', function(){
          $(this).fadeTo(100,1);
        });
      });
      return false;
    });
*/
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js